import FixaSSRIcon from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/FixaSSRIcon";
import CheckmarkGreenSmallIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/CheckmarkGreenSmallPath";
import NoticeRedSmallIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/NoticeRedSmallIconPath";
import styles from "./task-notification.module.css";

const TaskNotificationStatus = ({
  status,
}: {
  status: "completed" | "closed";
}) => {
  return (
    <div className={styles["task-notification-item-body-status"] ?? ""}>
      {status === "completed" ? (
        <FixaSSRIcon paths={CheckmarkGreenSmallIconPath} />
      ) : (
        <FixaSSRIcon paths={NoticeRedSmallIconPath} />
      )}
    </div>
  );
};

export default TaskNotificationStatus;
